import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PriceCardData } from '@price-card/models/price-card-data.model';
import { RootState } from '@store/create-store';

export type RetrievePriceCardDataPayload = {
  commercialOperationDateIds: number[];
  priceZoneId: number;
  technologyId: number;
};

export type RetrievePriceCardDataSuccessPayload = {
  codPriceCardIdMap: Record<number, number>;
  priceCardData: PriceCardData[];
};

export interface PriceCardDataState {
  codPriceCardIdMap: Record<number, number>;
  priceCardData: PriceCardData[];
  lastQuery?: RetrievePriceCardDataPayload;
  isFetching: boolean;
  error?: string;
}

const initialState: PriceCardDataState = {
  codPriceCardIdMap: {},
  priceCardData: [],
  isFetching: false,
};

export const priceCardDataSlice = createSlice({
  name: 'priceCardData',
  initialState,
  reducers: {
    retrievePriceCardData: (state, action: PayloadAction<RetrievePriceCardDataPayload>) => {
      state.isFetching = true;
      state.codPriceCardIdMap = {};
      state.priceCardData = [];
      state.error = undefined;
      state.lastQuery = action.payload;
    },
    retrievePriceCardDataSuccess: (state, action: PayloadAction<RetrievePriceCardDataSuccessPayload>) => {
      state.priceCardData = action.payload.priceCardData;
      state.codPriceCardIdMap = action.payload.codPriceCardIdMap;
      state.isFetching = false;
    },
    retrievePriceCardDataFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export const { retrievePriceCardData, retrievePriceCardDataSuccess, retrievePriceCardDataFailure } =
  priceCardDataSlice.actions;

export const selectPriceCardData = (state: RootState) =>
  state.priceCard.priceCardData.priceCardData;
export const selectCodPriceCardIdMap = (state: RootState) =>
  state.priceCard.priceCardData.codPriceCardIdMap;
export const selectPriceCardDataIsFetching = (state: RootState) =>
  state.priceCard.priceCardData.isFetching;
export const selectPriceCardDataLastQuery = (state: RootState) =>
  state.priceCard.priceCardData.lastQuery;

export default priceCardDataSlice.reducer;
